"use client"

import { useSyncExternalStore } from "react"

import { useQueryClient } from "@tanstack/react-query"

import { currentViewer, isProbeKey } from "@/platform/session/current-viewer"
import { useRevocation } from "@/platform/session/use-revocation"

export const useViewer = (): string | null => {
  const queryClient = useQueryClient()
  const revocation = useRevocation(queryClient)
  const viewer = useSyncExternalStore(
    (listener) => queryClient.getQueryCache().subscribe((event) => isProbeKey(event.query.queryKey) && listener()),
    () => currentViewer(queryClient),
    () => currentViewer(queryClient)
  )
  return revocation === "none" ? viewer : null
}
